import React from "react";
import { Plus, X } from "lucide-react";
import { ImageField } from "./ImageField";

const EMPTY = { name: "", meta: "", img: "", url: "" };
const inp = "w-full bg-white border border-[color:var(--line)] rounded-xl px-3 py-2 text-sm outline-none focus:border-[color:var(--ocean)]";

export const TilesField = ({ tid, value = [], onChange, uploadPath }) => {
  const tiles = value || [];
  const set = (i, k, v) => onChange(tiles.map((t, j) => (j === i ? { ...t, [k]: v } : t)));
  return (
    <div className="space-y-3" data-testid={tid}>
      <p className="text-xs text-[color:var(--ink-2)]">Up to 4 clickable tiles shown beside the ad copy (e.g. individual tours or offers). Leave empty for a copy-only banner.</p>
      {tiles.map((t, i) => (
        <div key={i} className="rounded-2xl border border-[color:var(--line)] bg-[color:var(--sand)]/30 p-4 grid grid-cols-1 md:grid-cols-2 gap-3 relative" data-testid={`${tid}-${i}`}>
          <button type="button" onClick={() => onChange(tiles.filter((_, j) => j !== i))} data-testid={`${tid}-remove-${i}`} className="absolute top-2 right-2 p-1.5 rounded-full hover:bg-white" title="Remove tile"><X size={14} /></button>
          <input data-testid={`${tid}-${i}-name`} placeholder="Tile title (e.g. Cape York Pajinka Tour)" value={t.name} onChange={(e) => set(i, "name", e.target.value)} className={inp} />
          <input data-testid={`${tid}-${i}-meta`} placeholder="Small line (e.g. 14 days · from $2,997)" value={t.meta} onChange={(e) => set(i, "meta", e.target.value)} className={inp} />
          <input data-testid={`${tid}-${i}-url`} type="url" placeholder="Link when clicked (https://…)" value={t.url} onChange={(e) => set(i, "url", e.target.value)} className={`${inp} md:col-span-2`} />
          <div className="md:col-span-2"><ImageField tid={`${tid}-${i}-img`} value={t.img} onChange={(v) => set(i, "img", v)} uploadPath={uploadPath} /></div>
        </div>
      ))}
      {tiles.length < 4 && (
        <button type="button" onClick={() => onChange([...tiles, { ...EMPTY }])} data-testid={`${tid}-add`} className="btn-pill btn-outline text-xs"><Plus size={13} /> Add tile</button>
      )}
    </div>
  );
};
